import React from "react";

import "../../../styles/tutorial.scss";

function LoteriaPopular() {
  return (
    <div class="container_como_jogar">
      <div>
        <h1>Saiba como jogar!</h1>
        <h2>Como Jogar</h2>

        <p>
          Apostar é muito simples: basta escolher uma modalidade de aposta, um ou mais números, 
          os Prêmios em que se deseja concorrer e o valor que se deseja apostar. Finalmente escolha um sorteio.
        </p>
        <p>
          Ao confirmar a aposta, é só esperar o sorteio e ficar na torcida! 
        </p>

        <h2>Sorteios</h2>
        <p>
          Cada horário sorteia 5 ou mais milhares (de 0000 a 9999). Estes sorteios são 
          chamados de Prêmios.
        </p>
        <p>Exemplo de números sorteados em um sorteio:</p>
        <ul>
          <li>1º Prêmio: 1124</li>
          <li>2º Prêmio: 3857</li>
          <li>3º Prêmio: 0280</li>
          <li>4º Prêmio: 4577</li>
          <li>5º Prêmio: 2021</li>
        </ul>
        <h2>Como jogar</h2>
        <p>
        Para participar, o jogador deve conhecer os 25 animais disponíveis. 
        Cada um representa 4 dezenas, deste modo, o grupo equivale a uma 
        aposta em 4 dezenas. São eles:
        </p>
        <div class="table-wrapper">
          <table width="760px" height="300px">
            <tr>
              <td>
                GRUPO 1<br />
                Avestruz
                <br />
                01, 02, 03, 04
              </td>
              <td>
                GRUPO 2<br />
                Águia
                <br />
                05, 06, 07, 08
              </td>
              <td>
                GRUPO 3<br />
                Burro
                <br />
                09, 10, 11, 12
              </td>
              <td>
                GRUPO 4<br />
                Borboleta
                <br />
                13, 14, 15, 16
              </td>
              <td>
                GRUPO 5<br />
                Cachorro
                <br />
                17, 18, 19, 20
              </td>
            </tr>
            <tr>
              <td>
                GRUPO 6<br />
                Cabra
                <br />
                21, 22, 23, 24
              </td>
              <td>
                GRUPO 7<br />
                Carneiro
                <br />
                25, 26, 27, 28
              </td>
              <td>
                GRUPO 8<br />
                Camelo
                <br />
                29, 30, 31, 32
              </td>
              <td>
                GRUPO 9<br />
                Cobra
                <br />
                33, 34, 35, 36
              </td>
              <td>
                GRUPO 10
                <br />
                Coelho
                <br />
                37, 38, 39, 40
              </td>
            </tr>
            <tr>
              <td>
                GRUPO 11
                <br />
                Cavalo
                <br />
                41, 42, 43, 44
              </td>
              <td>
                GRUPO 12
                <br />
                Elefante
                <br />
                45, 46, 47, 48
              </td>
              <td>
                GRUPO 13
                <br />
                Galo
                <br />
                49, 50, 51, 52
              </td>
              <td>
                GRUPO 14
                <br />
                Gato
                <br />
                53, 54, 55, 56
              </td>
              <td>
                GRUPO 15
                <br />
                jacaré
                <br />
                57, 58, 59, 60
              </td>
            </tr>
            <tr>
              <td>
                GRUPO 16
                <br />
                Leão
                <br />
                61, 62, 63, 64
              </td>
              <td>
                GRUPO 17
                <br />
                Macaco
                <br />
                65, 66, 67, 68
              </td>
              <td>
                GRUPO 18
                <br />
                Porco
                <br />
                69, 70, 71, 72
              </td>
              <td>
                GRUPO 19
                <br />
                Pavão
                <br />
                73, 74, 75, 76
              </td>
              <td>
                GRUPO 20
                <br />
                Peru
                <br />
                77, 78, 79, 80
              </td>
            </tr>
            <tr>
              <td>
                GRUPO 21
                <br />
                Touro
                <br />
                81, 82, 83, 84
              </td>
              <td>
                GRUPO 22
                <br />
                Tigre
                <br />
                85, 86, 87, 88
              </td>
              <td>
                GRUPO 23
                <br />
                Urso
                <br />
                89, 90, 91, 92
              </td>
              <td>
                GRUPO 24
                <br />
                Veado
                <br />
                93, 94, 95, 96
              </td>
              <td>
                GRUPO 25
                <br />
                Vaca
                <br />
                97, 98, 99, 00
              </td>
            </tr>
          </table>
        </div>
        <p>
          Os valores descritos abaixo são representações apenas de exemplo, 
          a cotação de cada jogo deve ser vista na aba cotações.
        </p>
        <h2>Modalidades de apostas</h2>
        <h3>Grupo</h3>
        <p>
          Também conhecida como "grupo" ou "aposta simples". 
          Para participar, basta escolher um ou mais animais. 
          Nesta modalidade, o jogador faz um palpite seco e concorre apenas ao primeiro prêmio.
        </p>
        <p>
          Para compreendermos o jogo, vamos considerar os seguintes resultados:
        </p>
        <ul>
          <li>1º prêmio: 1901</li>
          <li>2º prêmio: 3018</li>
          <li>3º prêmio: 6423</li>
          <li>4º prêmio: 8408</li>
          <li>5º prêmio: 2352</li>
        </ul>
        <p>
          Seguindo os resultados determinados anteriormente, o ganhador será aquele que escolheu 
          o avestruz (1901), que representa as dezenas 01, 02, 03 e 04.
        </p>
        <p>
          Para aumentar as chances de ganhar, pode-se apostar em mais de um grupo e mais de um Prêmio 
          do sorteio. Neste caso, para efeito de cálculo de premiação, o valor apostado é rateado entre 
          a quantidade de números e Prêmios escolhidos. Veja o exemplo:
        </p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Grupo</th>
              <td>01</td>
              <td>1°</td>
              <td>R$ 1,00</td>
              <td>R$ 17,50</td>
            </tr>
            <tr>
              <th scope="row">Grupo</th>
              <td>01</td>
              <td>2°</td>
              <td>R$ 2,00</td>
              <td>R$ 35,00</td>
            </tr>
            <tr>
              <th scope="row">Grupo</th>
              <td>01</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 3,50*</td>
            </tr>
            <tr>
              <th scope="row">Grupo</th>
              <td>01</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 1,75*</td>
            </tr>
          </table>
        </div>
        <p>*Ganho para cada grupo e prêmio acertado.</p>
        <ul>
          <li>1º Prêmio: 1124</li>
          <li>2º Prêmio: 3802</li>
          <li>3º Prêmio: 0280</li>
          <li>4º Prêmio: 4504</li>
          <li>5º Prêmio: 2008</li>
        </ul>
        <p>
          <b>Considerando os resultados acima:</b>
        </p>
        <ul>
          <li>A primeira aposta não seria premiada;</li>
          <li>A segunda aposta seria premiada em R$35,00;</li>
          <li>
            A terceira aposta seria premiada no 2º e 4º Prêmios, fazendo jus a
            R$7,00;
          </li>
          <li>
            A quarta aposta seria premiada no 2º, 4º Prêmios (com o grupo 01) e
            5º Prêmio (com o grupo 02), fazendo jus a R$5,25.
          </li>
        </ul>
        <h3>Dezena</h3>
        <p>
          Nesta modalidade de aposta, o apostador escolhe uma ou mais dezenas de 00 a 99. 
          Então, se o milhar sorteada terminar com 20 (ex: 1920, 2020), acertaram os jogadores 
          que tiverem escolhido a dezena 20!
        </p>
        <p>
          Para aumentar as chances de ganhar, pode-se apostar em mais de uma dezena e mais de 
          um Prêmio do sorteio. Neste caso, para efeito de cálculo de premiação, o valor apostado 
          é rateado entre a quantidade de números e Prêmios escolhidos.
        </p>
        <p>Exemplos de premiação:</p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Dezena</th>
              <td>20</td>
              <td>1°</td>
              <td>R$ 1,00</td>
              <td>R$ 70,00</td>
            </tr>
            <tr>
              <th scope="row">Dezena</th>
              <td>20</td>
              <td>2°</td>
              <td>R$ 2,00</td>
              <td>R$ 140,00</td>
            </tr>
            <tr>
              <th scope="row">Dezena</th>
              <td>20</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 14,00*</td>
            </tr>
            <tr>
              <th scope="row">Dezena</th>
              <td>20, 40</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 7,00*</td>
            </tr>
          </table>
        </div>
        <p>*Ganho pra cada dezena e prêmio acertado.</p>
        <p>Para o sorteio abaixo:</p>
        <ul>
          <li>a primeira aposta não seria premiada;</li>
          <li>a segunda aposta seria premiada em $140,00;</li>
          <li>
            a terceira aposta seria premiada no 2º e 4º Prêmios, fazendo jus a
            $28,00;
          </li>
          <li>
            a quarta aposta seria premiada no 2º, 4º Prêmios (com a dezena 20) e
            5º Prêmio (com a dezena 40), fazendo jus a $21,00.
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 3024</li>
          <li>2º Prêmio: 2420</li>
          <li>3º Prêmio: 6680</li>
          <li>4º Prêmio: 8920</li>
          <li>5º Prêmio: 0140</li>
        </ul>
        <p>Centena</p>
        <p>
          A mecânica é bem parecida com a dezena, sendo que o apostador escolhe uma ou 
          mais centenas de 000 a 999. Se o milhar sorteada terminar com 020 (ex 1020, 2020), 
          acertaram os jogadores que tiverem escolhido a centena 020!
        </p>
        <p>
          Para aumentar as chances de ganhar, pode-se apostar em mais de uma centena e mais de 
          um Prêmio do sorteio. Neste caso, para efeito de cálculo de premiação, o valor apostado 
          é rateado entre a quantidade de números e Prêmios escolhidos.
        </p>
        <p>Exemplos de premiação:</p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Centena</th>
              <td>420</td>
              <td>1°</td>
              <td>R$ 1,00</td>
              <td>R$ 700,00</td>
            </tr>
            <tr>
              <th scope="row">Centena</th>
              <td>420</td>
              <td>2°</td>
              <td>R$ 2,00</td>
              <td>R$ 1400,00</td>
            </tr>
            <tr>
              <th scope="row">Centena</th>
              <td>420</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 140,00*</td>
            </tr>
            <tr>
              <th scope="row">Centena</th>
              <td>920, 940</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 70,00*</td>
            </tr>
          </table>
        </div>
        <p>*Ganho para cada Centena e prêmio acertado.</p>
        <p>
          <b>Para o sorteio abaixo:</b>
        </p>
        <ul>
          <li>a primeira aposta não seria premiada;</li>
          <li>a segunda aposta seria premiada em $1.400,00;</li>
          <li>
            a terceira aposta seria premiada no 2º Prêmio, fazendo jus a
            $140,00;
          </li>
          <li>
            a quarta aposta seria premiada no 2º (com a centena 420) e 4º
            Prêmios (com centena 920), fazendo jus a $140,00.
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 3024</li>
          <li>2º Prêmio: 2420</li>
          <li>3º Prêmio: 6680</li>
          <li>4º Prêmio: 8920</li>
          <li>5º Prêmio: 0140</li>
        </ul>
        <p>Milhar</p>
        <p>
          A milhar é uma das modalidades preferidas dentre os apostadores. Para ganhar é
          necessário acertar o exato milhar sorteado! Se o milhar sorteado for 1523, acertaram 
          os jogadores que tiverem escolhido o milhar 1523!
        </p>
        <p>
          Muitos apostadores apostam em milhares relacionados a fatos do dia a dia que 
          chamem sua atenção, como os últimos 4 dígitos do número de um telefone, ou a 
          placa de um carro!
        </p>
        <p>
          Para aumentar as chances de ganhar, pode-se apostar em mais de um milhar e mais 
          de um Prêmio do sorteio. Neste caso, para efeito de cálculo de premiação, o valor 
          apostado é rateado entre a quantidade de números e Prêmios escolhidos.
        </p>
        <p>Exemplos de premiação:</p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Milhar</th>
              <td>3420</td>
              <td>1°</td>
              <td>R$ 1,00</td>
              <td>R$ 7000,00</td>
            </tr>
            <tr>
              <th scope="row">Milhar</th>
              <td>2420</td>
              <td>2°</td>
              <td>R$ 2,00</td>
              <td>R$ 14.000,00</td>
            </tr>
            <tr>
              <th scope="row">Milhar</th>
              <td>2420</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 1.400,00*</td>
            </tr>
            <tr>
              <th scope="row">Milhar</th>
              <td>8920, 1420</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 700,00*</td>
            </tr>
          </table>
        </div>
        <p>*Ganho para cada milhar e prêmio acertado.</p>
        <p>
          <b>Para o sorteio abaixo:</b>
        </p>
        <ul>
          <li>A primeira aposta não seria premiada;</li>
          <li>A segunda aposta seria premiada em R$14.000,00;</li>
          <li>
            A terceira aposta seria premiada no 2º Prêmio, fazendo jus a
            R$1.400,00;
          </li>
          <li>
            A quarta aposta seria premiada no 5º (com a centena 8920), fazendo
            jus a R$700,00.
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 3024</li>
          <li>2º Prêmio: 2420&nbsp;</li>
          <li>3º Prêmio: 6680</li>
          <li>4º Prêmio: 8920</li>
          <li>5º Prêmio: 0140</li>
        </ul>
        <h3>Duque de grupos</h3>
        <p>
          No duque de grupos, o apostador escolhe dois grupos (bichos) e torce para 
          que ambos estejam dentre os cinco milhares sorteados.
        </p>
        <p>Exemplos de premiação:</p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio*</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Duque de grupos</th>
              <td>
                01 e 06
                <br />
                (avestruz e cabra)
              </td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 22,00</td>
            </tr>
            <tr>
              <th scope="row">Duque de grupos</th>
              <td>
                06 e 24
                <br />
                (cabra e veado)
              </td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 44,00</td>
            </tr>
            <tr>
              <th scope="row">Duque de grupos</th>
              <td>
                08 e 15
                <br />
                (camelo e jacaré)
              </td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 44,00</td>
            </tr>
          </table>
        </div>
        <p>*O prêmio é fixo do 1° ao 5º.</p>
        <p>
          <b>Para o sorteio abaixo:</b>
        </p>
        <ul>
          <li>
            A primeira aposta acertaria 2 Prêmios (1º com o grupo 01 e 2º com o
            grupo 06) e seria premiada em $22,00;
          </li>
          <li>
            A segunda aposta acertaria 1 Prêmio (2º com o grupo 06) e não seria
            premiada;
          </li>
          <li>
            A terceira aposta acertaria 2 Prêmios (3º com o grupo 08 e 4º com o
            grupo 15) e seria premiada em $44,00;
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 2301</li>
          <li>2º Prêmio: 1024</li>
          <li>3º Prêmio: 7431</li>
          <li>4º Prêmio: 1257</li>
          <li>5º Prêmio: 9877</li>
        </ul>
        <p>
          O apostador não ganha múltiplas vezes caso acerte mais de 2 grupos
          dentre os 5 milhares sorteados.
        </p>
        <h3>Terno de Grupos</h3>
        <p>
          O Terno de Grupos tem mecânica similar ao Duque de Grupos, sendo 
          que o apostador escolhe três animais (grupos) ao invés de dois. 
          O apostador é premiado caso todos os três grupos escolhidos estejam 
          dentre os cinco milhares sorteados.
        </p>
        <p>
          <b>Exemplos de premiação:</b>
        </p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio*</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Terno de grupos</th>
              <td>
                01, 18 e 25
                <br />
                (avestruz, porco e cabra)
              </td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 182,00</td>
            </tr>
            <tr>
              <th scope="row">Terno de grupos</th>
              <td>
                04, 08 e 24
                <br />
                (borboleta, camelo e veado)
              </td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 364,00</td>
            </tr>
            <tr>
              <th scope="row">Terno de grupos</th>
              <td>
                08, 15 e 18
                <br />
                (camelo, jacaré e porco)
              </td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 364,00</td>
            </tr>
          </table>
        </div>
        <p>*O prêmio é fixo do 1° ao 5º.</p>
        <p>Para o sorteio abaixo:</p>
        <ul>
          <li>
            a primeira aposta acertaria 2 Prêmios (1º com o grupo 01 e 5º com o
            grupo 18) e não seria premiada;
          </li>
          <li>
            a segunda aposta acertaria 1 Prêmio (2º com o grupo 08) e não seria
            premiada;
          </li>
          <li>
            a terceira aposta acertaria 3 Prêmios (2º com o grupo 08 e 4º com o
            grupo 15 e 5º com o grupo 18) e seria premiada em $364,00;
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 2301</li>
          <li>2º Prêmio: 1032</li>
          <li>3º Prêmio: 7497</li>
          <li>4º Prêmio: 1257</li>
          <li>5º Prêmio: 9872</li>
        </ul>
        <p>
          O apostador não ganha múltiplas vezes caso acerte mais de 3 grupos
          dentre os 5 milhares sorteados.
        </p>
        <h3>Duque de Dezenas</h3>
        <p>
          No duque de dezenas, o apostador escolhe duas dezenas e torce para 
          que ambas estejam dentre os cinco milhares sorteados.
        </p>
        <p>
          <b>Exemplos de premiação:</b>
        </p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio*</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Duque de dezenas</th>
              <td>24 e 72</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 350,00</td>
            </tr>
            <tr>
              <th scope="row">Duque de dezenas</th>
              <td>42 e 57</td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 700,00</td>
            </tr>
            <tr>
              <th scope="row">Duque de dezenas</th>
              <td>31 e 57</td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 700,00</td>
            </tr>
          </table>
        </div>
        <p>*O prêmio é fixo do 1° ao 5º.</p>
        <p>
          <b>Considerando os resultados acima:</b>
        </p>
        <ul>
          <li>
            A primeira aposta acertaria 2 Prêmios (2º com a dezena 24 e 5º com a
            dezena 72) e seria premiada em R$350,00;
          </li>
          <li>
            A segunda aposta acertaria 1 Prêmio (4º com a dezena 57) e não seria
            premiada;
          </li>
          <li>
            A terceira aposta acertaria 2 Prêmios (1º com a dezena 31 e 4º com a
            dezena 57) e seria premiada em R$700,00;
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 2300</li>
          <li>2º Prêmio: 1024</li>
          <li>3º Prêmio: 7431</li>
          <li>4º Prêmio: 1257</li>
          <li>5º Prêmio: 9872</li>
        </ul>
        <p>
          O apostador não ganha múltiplas vezes caso acerte mais de 2 dezenas
          dentre os 5 milhares sorteados.
        </p>
        <h3>Terno de Dezenas</h3>
        <p>
          O Terno de Dezenas tem mecânica similar ao Duque de Dezenas, 
          sendo que o apostador escolhe três dezenas ao invés de duas. 
          O apostador é premiado caso todas as três dezenas escolhidas 
          estejam dentre os cinco milhares sorteados.
        </p>
        <p>
          <b>Exemplos de premiação:</b>
        </p>
        <div class="table-wrapper">
          <table width="600px">
            <thead>
              <tr>
                <th>Modalidade</th>
                <th>Número</th>
                <th>Prêmio*</th>
                <th>Valor da aposta</th>
                <th>Ganho</th>
              </tr>
            </thead>
            <tr>
              <th scope="row">Terno de dezenas</th>
              <td>24, 72 e 87</td>
              <td>1° ao 5º</td>
              <td>R$ 1,00</td>
              <td>R$ 11.650,00</td>
            </tr>
            <tr>
              <th scope="row">Terno de dezenas</th>
              <td>42, 57 e 78</td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 23.300,00</td>
            </tr>
            <tr>
              <th scope="row">Terno de dezenas</th>
              <td>31, 57 e 72</td>
              <td>1° ao 5º</td>
              <td>R$ 2,00</td>
              <td>R$ 23.300,00</td>
            </tr>
          </table>
        </div>
        <p>*O prêmio é fixo do 1° ao 5º.</p>
        <p>
          <b>Para o sorteio abaixo:</b>
        </p>
        <ul>
          <li>
            A primeira aposta acertaria 2 Prêmios (2º com a dezena 24 e 5º com a
            dezena 72) e não seria premiada;
          </li>
          <li>
            A segunda aposta acertaria 1 Prêmio (4º com a dezena 57) e não seria
            premiada;
          </li>
          <li>
            A terceira aposta acertaria 3 Prêmios (3º com a dezena 31 e 4º com a
            dezena 57 e 5º com a dezena 72) e seria premiada em $23.300,00;
          </li>
        </ul>
        <ul>
          <li>1º Prêmio: 2300</li>
          <li>2º Prêmio: 1024</li>
          <li>3º Prêmio: 7431</li>
          <li>4º Prêmio: 1257</li>
          <li>5º Prêmio: 9872</li>
        </ul>
        <p>
          O apostador não ganha múltiplas vezes caso acerte mais de 3 dezenas
          dentre os 5 milhares sorteados.
        </p>
      </div>
    </div>
  );
}

export default LoteriaPopular;



// WEBPACK FOOTER //
// ./src/static/tutorial/loteria-popular/default.jsx